/* ══════════════════════════════════════════════════════════════════════════
   CASEMIRA · ANTIDÉRAPANT COUSU : LIGNE LIÉE AU TAPIS DANS LE PANIER  (02/11/2026)
   Brief casemira-demarchage-fournisseur/hosni-antiderapant-2026-10-14/
   BRIEF-SITE-ANTIDERAPANT-COUSU.md § 4 : « quantité égale à celle du tapis ;
   si le tapis est retiré du panier, l'antidérapant doit l'être aussi ».
   ──────────────────────────────────────────────────────────────────────────
   La fiche berbère (casemira-berbere-configurator.js) ajoute l'antidérapant en
   seconde ligne avec la propriété cachée `_Pour le tapis` = SKU du tapis. Ce
   script relit /cart.js après chaque changement du panier et, pour chaque
   ligne de l'antidérapant, ramène sa quantité à celle des lignes du tapis de
   même SKU (0 = retrait). UNE seule requête /cart/change.js par passe, puis
   `cart:refresh` : le tiroir se redessine et une nouvelle passe constate que
   tout est en ordre. Garde-fou : six passes au plus par dix secondes. Aucune
   boucle d'ajout, jamais d'écriture quand rien ne diverge.
   Chargé par sections/cart-drawer.liquid après casemira-cart.js.
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (window.__cmAntiderapantInit) return;
  window.__cmAntiderapantInit = true;

  var HANDLE = 'antiderapant-cousu-berbere';
  var LIEN = '_Pour le tapis';
  var RACINE = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var occupe = false, passes = 0, t0 = 0, minuterie = null;

  function divergence(cart) {
    var items = (cart && cart.items) || [], tapis = {}, i, it, sku, q;
    for (i = 0; i < items.length; i++) {
      it = items[i];
      if (it.handle !== HANDLE && it.sku) tapis[it.sku] = (tapis[it.sku] || 0) + it.quantity;
    }
    for (i = 0; i < items.length; i++) {
      it = items[i];
      if (it.handle !== HANDLE) continue;
      sku = it.properties && it.properties[LIEN];
      q = sku ? (tapis[sku] || 0) : it.quantity; /* sans clé de liaison (ajout manuel), on ne touche pas */
      if (it.quantity !== q) return { id: it.key, quantity: q };
    }
    return null;
  }

  function passe() {
    if (occupe) return;
    var now = Date.now();
    if (now - t0 > 10000) { t0 = now; passes = 0; }
    if (++passes > 6) return;
    occupe = true;
    fetch(RACINE + 'cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var a = divergence(cart);
        if (!a) { occupe = false; return null; }
        return fetch(RACINE + 'cart/change.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(a)
        }).then(function (r) { return r.json(); }).then(function (c) {
          occupe = false;
          document.querySelectorAll('.cart-count-bubble span, [data-cart-count], .cart-count, .js-cart-count, .header__cart-count')
            .forEach(function (el) { el.textContent = c.item_count; });
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: c } }));
        });
      })
      .catch(function (e) { occupe = false; if (window.console) console.warn('[Antidérapant]', e); });
  }
  function planifier() { clearTimeout(minuterie); minuterie = setTimeout(passe, 120); }

  ['cart:updated', 'cart:change', 'cart:refresh', 'cart-update'].forEach(function (ev) {
    document.addEventListener(ev, planifier);
  });
  /* Le tiroir Casemira publie chaque panier rendu sur le bus du thème
     (`FoxTheme.pubsub`, événement cartUpdate, casemira-cart.js § publie) : c'est
     le signal principal. Le bus peut arriver après ce script : on réessaie. */
  var essais = 0;
  function abonner() {
    try {
      var ps = window.FoxTheme && window.FoxTheme.pubsub;
      if (ps && typeof ps.subscribe === 'function' && ps.PUB_SUB_EVENTS && ps.PUB_SUB_EVENTS.cartUpdate) {
        ps.subscribe(ps.PUB_SUB_EVENTS.cartUpdate, planifier);
        return;
      }
    } catch (e) {}
    if (++essais < 25) setTimeout(abonner, 400);
  }
  abonner();
  /* Filet : toute réécriture des lignes du tiroir ou de la page panier relance une passe (sans écriture si rien ne diverge). */
  function observer() {
    var cibles = document.querySelectorAll('cart-drawer, [data-cmk-scene]');
    if (!cibles.length || !window.MutationObserver) return;
    var mo = new MutationObserver(planifier);
    cibles.forEach(function (c) { mo.observe(c, { childList: true, subtree: true }); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { observer(); planifier(); });
  else { observer(); planifier(); }
})();
